import BaseModal from "../BaseModal/BaseModal";
import languages from "../../utils/languages";
import {useDispatch, useSelector} from "react-redux";
import {setLanguage} from "../../redux/Reducers/language-slice";


export default function LanguageSelectionModal({className, ...props}) {
    const languagesSlice = useSelector(state => state.LanguageSlice);
    const dispatch = useDispatch();

    return (
        <BaseModal title={"Select Language"} innerClassName={` ${className} lg:w-1/2`}
                   {...props}
        >
            <div className={"flex flex-row px-4 py-4 flex-wrap gap-4"}>
                {
                    languages.map((language) => {
                        return (
                            <div
                                onClick={() => {
                                    dispatch(setLanguage(language))
                                }}
                                className={
                                    language.id !== languagesSlice.selectedLanguageId ?
                                        "border-[1px] rounded-full px-4 cursor-pointer"
                                        :
                                        "border-[1px] rounded-full px-4 cursor-pointer bg-blue-500 text-white"
                                }
                            >
                                <p>{language.nativeWriting}</p>
                            </div>
                        )
                    })
                }
            </div>
        </BaseModal>

    )
}